import React,{useState} from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
// import Navbar2 from '../components/Navbar2';

import Sroll from '../components/Scroll';
import AvailableRoomsPage from '../components/AvailableRooms';

function AvailableRooms() {
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }
    


    return (
        <div >
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} /> 
            <AvailableRoomsPage />
            <Sroll />
            <Footer />
        </div>
    )
}

export default AvailableRooms
